// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { DropZoneField, LabeledInput, LabeledTextarea } from 'components/Form'
import moment from 'moment'
import { validateNewCommentForm } from './helpers'

const idRoot = 'db-details-comments'
const bl = {
  borderLeft: '1px solid',
}

const Form = ({ error, handleSubmit }) => (
  <form
    className={'display-flex flex-wrap-wrap database-details-section db-details-comment-modal'}
    id={idRoot}>
    { error && <p className={'error-message width-100 margin-bottom-half'}>{error}</p>}
    <div className={'width-50 display-flex justify-content-between flex-wrap-wrap padding-right-1'}>
      <Field
        className={'hide-input-styles align-self-flex-start'}
        component={LabeledInput}
        disabled={true}
        id={`${idRoot}-user-name`}
        label={'User'}
        name={'userName'}
        placeholder={' '} />
      <Field
        className={'hide-input-styles align-self-flex-start'}
        component={LabeledInput}
        disabled={true}
        id={`${idRoot}-comment-date`}
        label={'Date'}
        format={v => moment(v).format('YYYY/MM/DD')}
        name={'commentDate'}
        placeholder={' '} />
      <Field
        autoFocus={true}
        className={'width-100'}
        component={LabeledTextarea}
        id={`${idRoot}-comment`}
        label={'Comment'}
        name={'comment'}
        placeholder={'Enter Comment'} />
    </div>
    <div
      className={'width-50 padding-left-1 display-flex flex-direction-column align-items-end'}
      style={bl}>
      <Field
        className={'width-100 margin-bottom-1'}
        component={DropZoneField}
        id={`${idRoot}-files`}
        name={'files'} />
      <button
        className={'btn btn-sm bg-green hover-inverse margin-top-1'}
        id={`${idRoot}-submit`}
        onClick={handleSubmit}
        type={'submit'}>
        {'Save'}
      </button>
    </div>
  </form>
)

Form.propTypes = {
  error: string,
  handleSubmit: func.isRequired,
}

export default reduxForm({
  form: idRoot,
  validate: validateNewCommentForm,
})(Form)
